<script setup lang="ts">
defineProps({
    descriptions: {
        type: Array,
        default: () => [],
    },
});
</script>

<template>
    <div class="privacy-item privacy__item">
        <div class="privacy-item__title"></div>

        <div class="privacy-item__content">
            <p
                v-for="(item, index) in descriptions"
                :key="`privacy-item-${item}-${index}`"
                class="privacy-item__text"
            >
                {{ item }}
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">
</style>
